import { types } from './actionTypes';
import { editDocumentData } from '../shared/document-utils';

export function handleVehicleDocuments(state: any, action: any) {
    if (action.type === types.GET_VEHICLE) {
        return editDocumentData(state, action);
    }
    return state;
}
